import { EditableCreditCard } from './editable-credit-card';
import { EditableDirectDebit } from './editable-direct-debit';

export type EditablePaymentMethod = EditableCreditCard | EditableDirectDebit;
